module.exports = __webpack_public_path__ + "img/Background.29e6e21b.png";